// Styles
import 'vuetify/styles';
import { aliases, mdi } from 'vuetify/iconsets/mdi'

// Vuetify
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
export default createVuetify({
  components,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
});
